<p-panel [style]="{ 'margin-top': '1em' }" styleClass="panel-shadow">
  <p-header class="flex justify-content-between">
    <div class="panel-header">Site Opening Hours</div>
  </p-header>

  <div class="flex flex-wrap" [class.ghost]="loadingTask">
    <div class="flex-grow-1">
      <div class="my-2" style="position: relative; margin-bottom: 0">
        <div style="font-weight: 700; font-size: 14px">Pick-up</div>
      </div>

      <div class="mb-2">
        <div class="ghost-fill font-medium">
          <i class="fa fa-map-marker" style="color: #999"></i>
          {{ pickupAddressString }}
        </div>
      </div>

      <ng-container *ngIf="taskSiteOpeningHours?.pickup?.length > 0">
        <div
          class="flex cursor-pointer"
          (click)="onlyTodayAndTomorrow.pickup = !onlyTodayAndTomorrow.pickup"
        >
          <div class="flex-shrink-1">
            <div *ngFor="let hours of filterDates(taskSiteOpeningHours.pickup, 'pickup')">
              <ng-template
                [ngTemplateOutlet]="openingHoursRow"
                [ngTemplateOutletContext]="{ $implicit: hours, toggleType: 'pickup' }"
              ></ng-template>
            </div>
          </div>
          <div class="flex-shrink-1">
            <div class="pl-3">
              <i
                class="fa"
                [class]="onlyTodayAndTomorrow.pickup ? 'fa-angle-down' : 'fa-angle-up'"
              ></i>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="mb-2 mt-4" style="position: relative; margin-bottom: 0">
        <div style="font-weight: 700; font-size: 14px">Drop-off</div>
      </div>

      <div class="mb-2">
        <div class="ghost-fill font-medium">
          <i class="fa fa-map-marker" style="color: #999"></i>
          {{ dropOffAddressString }}
        </div>
      </div>

      <ng-container *ngIf="taskSiteOpeningHours?.dropOff?.length > 0">
        <div
          class="flex cursor-pointer"
          (click)="onlyTodayAndTomorrow.dropOff = !onlyTodayAndTomorrow.dropOff"
        >
          <div class="flex-shrink-1">
            <div *ngFor="let hours of filterDates(taskSiteOpeningHours.dropOff, 'dropOff')">
              <ng-template
                [ngTemplateOutlet]="openingHoursRow"
                [ngTemplateOutletContext]="{ $implicit: hours, toggleType: 'dropOff' }"
              ></ng-template>
            </div>
          </div>
          <div class="flex-shrink-1">
            <div class="pl-3">
              <i
                class="fa"
                [class]="onlyTodayAndTomorrow.dropOff ? 'fa-angle-down' : 'fa-angle-up'"
              ></i>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div
      class="flex-grow-1 text-right"
      *ngIf="organisationTypeId == OrganisationTypeEnum.Engineius"
    >
      <button
        pButton
        class="ui-button ui-button-secondary"
        label="Change"
        (click)="editHours()"
      ></button>
    </div>
  </div>
</p-panel>

<ng-template #openingHoursRow let-hoursUntyped let-toggleType="toggleType">
  <ng-container *ngIf="asSiteHours(hoursUntyped) as hours">
    <ng-container *ngIf="hours && !hours.unspecified">
      <div class="mb-1 label-value-grid" *ngIf="!hours.isClosed">
        <div>{{ dayOfWeekName(hours.dayOfWeek, toggleType) }}:</div>
        <div class="value">{{ hours.open }} - {{ hours.close }}</div>
      </div>
      <div class="mb-1 label-value-grid" *ngIf="hours.isClosed">
        <div>{{ dayOfWeekName(hours.dayOfWeek, toggleType) }}:</div>
        <div class="value" style="color: #808080">Closed</div>
      </div>
    </ng-container>
    <ng-container *ngIf="hours && hours.unspecified">
      <div class="mb-1 label-value-grid">
        <div>{{ dayOfWeekName(hours.dayOfWeek, toggleType) }}:</div>
        <div class="value" style="color: #808080">Not Specified</div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<p-dialog
  [(visible)]="editVisible"
  header="Edit Site Opening Times"
  [style.width]="'800px'"
  [modal]="true"
>
  <div class="grid w-full">
    <div class="col-6">
      <div style="font-size: 14px; font-weight: 700">Pick-up</div>

      <div *ngIf="task?.pickupLocation" class="font-bold text-gray-600">
        <div>
          <div>{{ task?.pickupLocation?.businessName }}</div>
          <div
            *ngFor="
              let item of task?.pickupLocation?.primaryAddress
                .replace(task?.pickupLocation?.postcode, '')
                .split(',')
            "
          >
            {{ item }}
          </div>
          <div>{{ task?.pickupLocation?.postcode | postcode }}</div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div style="font-size: 14px; font-weight: 700">Drop-off</div>

      <div *ngIf="task?.dropOffLocation" class="font-bold text-gray-600">
        <div>
          <div>{{ task?.dropOffLocation?.businessName }}</div>
          <div
            *ngFor="
              let item of task?.dropOffLocation?.primaryAddress
                .replace(task?.dropOffLocation?.postcode, '')
                .split(',')
            "
          >
            {{ item }}
          </div>
          <div>{{ task?.dropOffLocation?.postcode | postcode }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="grid w-full">
    <div class="col-6">
      <customer-sites-opening-times
        *ngIf="pickupSiteHoursFormGroup"
        [openingTimesForm]="pickupSiteHoursFormGroup"
      ></customer-sites-opening-times>
    </div>
    <div class="col-6">
      <customer-sites-opening-times
        *ngIf="dropOffSiteHoursFormGroup"
        [openingTimesForm]="dropOffSiteHoursFormGroup"
      ></customer-sites-opening-times>
    </div>
  </div>
  <p-footer class="rounded-bottom-border">
    <div class="text-right">
      <button
        label="Close"
        class="ui-button ui-button-tertiary"
        pButton
        (click)="editVisible = false"
      ></button>
      <button
        label="Save"
        *ngIf="pickupSiteHoursFormGroup && dropOffSiteHoursFormGroup"
        class="ui-button ui-button-primary"
        pButton
        (click)="saveOpeniningHours()"
        [disabled]="pickupSiteHoursFormGroup.invalid || dropOffSiteHoursFormGroup.invalid"
      ></button>
    </div>
  </p-footer>
</p-dialog>
